import { clearAuthUserData } from '@/services/api'

import { sessionRecorder } from '@/services/sessionRecorder'

const LogoutComponent = {
  name: 'logout-component',
  components: {},
  mounted: function () {
    this.logout()
  },
  methods: {
    logout: function () {
      clearAuthUserData()
      sessionRecorder.stopRecordingSession()
      this.$router.push({
        name: 'app', // Update to login-social later
        params: {}
      })
    }
  }
}

export default LogoutComponent
